import React from "react";
import "../../assets/styles/smu-skirt.scss";
import { IconCheveron } from "../../icons/Icon";

const SmuSkirt = (props) => {
  const {
    style,
    controls,
    children,
    positionToggle = "right",
    isOpen,
    onToggle,
    hasChild,
    active,
    dragOverProps,
    openClickInIndicator = false,
  } = props;
  const handleGeneralClick = (event) => {
    if (!openClickInIndicator && !!onToggle) onToggle(event);
  };

  const handleIndicatorClick = (event) => {
    if (!!openClickInIndicator && !!onToggle) onToggle(event);
  };

  return (
    <div className="skirt" style={style || {}} {...dragOverProps}>
      <div className={`main-content ${active ? "active" : ""}`}>
        {children}
        {hasChild && positionToggle === "left" && (
          <div
            className={`toggle-indicator ${isOpen ? "open" : ""}`}
            onClick={(event) => handleIndicatorClick(event)}
          >
            <IconCheveron color="#33383F" />
          </div>
        )}
        <div className="controls">{controls}</div>
        {hasChild && positionToggle === "right" && (
          <div
            className={`toggle-indicator ${isOpen ? "open" : ""}`}
            onClick={(event) => handleGeneralClick(event)}
          >
            <IconCheveron color="#33383F" />
          </div>
        )}
      </div>
    </div>
  );
};

export default SmuSkirt;
